module.exports = __webpack_public_path__ + "static/BrushStrokeRight-a6f0f5abd2920c63ae6946401d1c9017.png";